import script from "./PositionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PositionList.vue?vue&type=script&setup=true&lang=ts"

import "./PositionList.scss?vue&type=style&index=0&id=7dcea94e&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dcea94e"]])

export default __exports__